import { render, staticRenderFns } from "./ListCouponsPage.vue?vue&type=template&id=2fa937c8"
import script from "./ListCouponsPage.vue?vue&type=script&lang=js"
export * from "./ListCouponsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports